// Compteur discret du menu « Courrier écarté » : nombre d'e-mails écartés par
// le tri (règles et IA). Relu toutes les 5 minutes et après chaque
// « Créer un dossier quand même ». Une lecture impossible (droits, serveur
// ancien sans la route) n'affiche simplement rien.

import { useEffect, useState } from 'react';
import { chargerCourrierEcarte, EVENEMENT_COURRIER_MODIFIE } from './courrier';

export const INTERVALLE_COMPTEUR_MS = 5 * 60 * 1000;

export function useCompteurCourrierEcarte(actif: boolean): number | null {
  const [total, setTotal] = useState<number | null>(null);

  useEffect(() => {
    if (!actif) { setTotal(null); return; }
    let vivant = true;
    const lire = () => {
      // Promise.resolve().then : une erreur levée avant la promesse est rattrapée aussi.
      Promise.resolve()
        .then(() => chargerCourrierEcarte({ page: 1 }))
        .then(p => { if (vivant) setTotal(p.total); })
        .catch(() => { if (vivant) setTotal(null); });
    };
    lire();
    const minuterie = window.setInterval(lire, INTERVALLE_COMPTEUR_MS);
    window.addEventListener(EVENEMENT_COURRIER_MODIFIE, lire);
    return () => {
      vivant = false;
      window.clearInterval(minuterie);
      window.removeEventListener(EVENEMENT_COURRIER_MODIFIE, lire);
    };
  }, [actif]);

  return total;
}
